import { normalizeSynonyms } from './synonym-expander';
/**
 * Load product index and synonyms from the backend API.
 * Caches results in sessionStorage for the current session.
 */
export async function loadIndex(config) {
    const cacheKey = `eno-search-index-${config.lang}-${config.indexVersion}`;
    // Try to load from session storage first
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) {
        try {
            return JSON.parse(cached);
        }
        catch (e) {
            // Invalid cache, continue to fetch
            console.warn('EnoWooSearch: Invalid cache, fetching fresh index');
        }
    }
    try {
        const response = await fetch(config.apiUrl, {
            headers: {
                'X-WP-Nonce': config.nonce,
            },
        });
        if (!response.ok) {
            throw new Error(`Failed to load index: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        // Validate data structure
        if (!Array.isArray(data.products) || typeof data.synonyms !== 'object') {
            throw new Error('Invalid index data structure');
        }
        // Normalize synonym dictionary keys to lowercase so lookups are
        // case-insensitive regardless of how the admin entered them.
        data.synonyms = normalizeSynonyms(data.synonyms);
        // Cache in sessionStorage on a best-effort basis — large catalogs can exceed the
        // browser's per-origin storage quota, and a failure here must not be treated as a
        // failure to load the index (the fetch above already succeeded with valid data).
        try {
            sessionStorage.setItem(cacheKey, JSON.stringify(data));
        }
        catch (cacheError) {
            console.warn('EnoWooSearch: Could not cache search index in sessionStorage', cacheError);
        }
        return data;
    }
    catch (error) {
        console.error('EnoWooSearch: Failed to load search index', error);
        throw error instanceof Error ? error : new Error('Network error while loading index');
    }
}
